(() => {
  const replacements = new Map([
    ['Home', 'Accueil'],
    ['Catalog', 'Catalogue'],
    ['Contact', 'Contact'],
    ['More', 'Menu'],
    ['Account', 'Compte'],
    ['Terms and Policies', 'Conditions et politiques'],
    ['Add to cart', 'Commander'],
    ['Add', 'Ajouter'],
    ['Cart', 'Panier'],
    ['Search', 'Rechercher'],
    ['You may also like', 'Vous aimerez aussi'],
    ['View all', 'Voir tout'],
    ['Join our email list', 'Recevez nos offres'],
    ['Get exclusive deals and early access to new products.', 'Promotions, nouveautes et conseils bebe directement par email.'],
    ['Sign up', 'S inscrire'],
    ['Email address', 'Adresse email'],
    ['More payment options', '']
  ]);

  const phraseReplacements = [
    [/\bRepas\s+Meal\b/gi, 'Repas'],
    [/\bMeal\s+Repas\b/gi, 'Repas'],
    [/\bMeals\b/gi, 'Repas'],
    [/\bMeal\b/gi, 'Repas'],
    [/\bBaby\b/gi, 'Bébé'],
    [/\bMaternity\b/gi, 'Maternité'],
    [/\bMom\b/gi, 'Maman'],
    [/\bMum\b/gi, 'Maman'],
    [/\bMother\b/gi, 'Maman'],
    [/\bBreastfeeding\b/gi, 'Allaitement'],
    [/\bFeeding\b/gi, 'Repas'],
    [/\bSleep\b/gi, 'Sommeil'],
    [/\bClothing\b/gi, 'Vêtements'],
    [/\bClothes\b/gi, 'Vêtements'],
    [/\bHygiene\b/gi, 'Hygiène'],
    [/\bGifts\b/gi, 'Cadeaux'],
    [/\bGift\b/gi, 'Cadeaux'],
    [/\bSale\b/gi, 'Promotions'],
    [/\bDeals\b/gi, 'Promotions'],
    [/\bPromos\b/gi, 'Promos']
  ];

  const cleanMixedLabel = (text) => {
    let next = text;
    phraseReplacements.forEach(([pattern, replacement]) => {
      next = next.replace(pattern, replacement);
    });
    next = next
      .replace(/\b(Repas)\s+\1\b/gi, '$1')
      .replace(/\b(Bébé)\s+\1\b/gi, '$1')
      .replace(/\b(Maman)\s+\1\b/gi, '$1')
      .replace(/\b(Allaitement)\s+\1\b/gi, '$1')
      .replace(/\b(Sommeil)\s+\1\b/gi, '$1')
      .replace(/\b(Vêtements)\s+\1\b/gi, '$1')
      .replace(/\b(Hygiène)\s+\1\b/gi, '$1')
      .replace(/\b(Cadeaux)\s+\1\b/gi, '$1')
      .replace(/\b(Promotions)\s+\1\b/gi, '$1');
    return next;
  };

  const translateTextNodes = () => {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const value = node.nodeValue.trim();
      if (replacements.has(value)) {
        node.nodeValue = node.nodeValue.replace(value, replacements.get(value));
      } else {
        const cleaned = cleanMixedLabel(node.nodeValue);
        if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
      }
    });
  };

  const translateAttributes = () => {
    document.querySelectorAll('[aria-label], [title], [placeholder]').forEach((element) => {
      ['aria-label', 'title', 'placeholder'].forEach((attr) => {
        const value = element.getAttribute(attr);
        if (!value) return;
        const exact = replacements.get(value.trim());
        const next = exact || cleanMixedLabel(value);
        if (next !== value) element.setAttribute(attr, next);
      });
    });
  };

  const hideAcceleratedCheckout = () => {
    document
      .querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons')
      .forEach((element) => {
        element.setAttribute('hidden', '');
      });
  };

  const run = () => {
    translateTextNodes();
    translateAttributes();
    hideAcceleratedCheckout();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
